import React, { useEffect, useState } from "react";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  updateDoc,
  writeBatch,
  serverTimestamp,
} from "firebase/firestore";
import { firestore, GeoFirestore } from "../../../../firebase";
import firebase from "firebase/compat/app";
import ngeohash from "ngeohash";
import "firebase/compat/firestore";
const db = firestore;

const SportsAPIComponent = ({ currentBusinessID, businessLocations }) => {
  const [data, setData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [fixtures, setFixtures] = useState([]);

  const [eventLocation, setEventLocation] = useState(null);

  const countries = [
    "",
    "Norway",
    "Sweden",
    "Denmark",
    "Finland",
    "Iceland",
    "Germany",
    "France",
    "Spain",
    "Italy",
    "England",
  ];

  const onGetTeamsFromCountry = async (country) => {
    console.log("Fetching data for:", country);
    if (!country) return;

    const res = await fetch(
      `https://v3.football.api-sports.io/teams?country=${country}`,
      {
        method: "GET",
        headers: {
          "x-apisports-key": "a202f9301e4e12173743da91a7297d88",
        },
      },
    );

    const data = await res.json();
    setData(data.response);
    console.log("Football API Data:", data);
  };

  const filteredData = data
    ? data.filter((teamInfo) =>
        teamInfo.team.name.toLowerCase().includes(searchTerm.toLowerCase()),
      )
    : [];

  const handleSelect = (team) => (e) => {
    const checked = e.target.checked;
    setSelectedTeams((prev) => {
      if (checked) {
        // Add if not already selected
        return [...prev, team];
      } else {
        // Remove if unchecked
        return prev.filter((t) => t.id !== team.id);
      }
    });
  };

  useEffect(() => {
    console.log("Selected Teams:", selectedTeams);
  }, [selectedTeams]);

  const getFixtures = async () => {
    const teamsArray = selectedTeams.map((team) => team.id);
    console.log("Getting fixtures for teams:", teamsArray);
    const homeFixtures = [];

    for (const teamId of teamsArray) {
      const res = await fetch(
        `https://v3.football.api-sports.io/fixtures?team=${teamId}&next=25`,
        {
          method: "GET",
          headers: {
            "x-apisports-key": "a202f9301e4e12173743da91a7297d88",
          },
        },
      );
      const data = await res.json();
      console.log("Fixtures data for team", teamId, ":", data);

      for (const fixture of data.response) {
        if (fixture.teams.home.id === teamId) {
          homeFixtures.push(fixture);
        }
      }
    }
    const ticketURL = eventLocation.data().website;
    console.log("Ticket URL:", ticketURL);

    console.log(homeFixtures);
    const lang = eventLocation.data().lang
      ? eventLocation.data().lang
      : "nb_NO";
    const currency = eventLocation.data().currency
      ? eventLocation.data().currency
      : "NOK";

    const fixturesFixed = [];
    homeFixtures.forEach((fixture) => {
      const nameFix =
        fixture.teams.home.name === "Bodo/Glimt"
          ? "Bodø/Glimt"
          : fixture.teams.home.name;
      const date = new Date(
        fixture.fixture.timestamp * 1000,
      ).toLocaleDateString("nb-NO", {
        day: "2-digit", // Ensure the day is two digits
        month: "2-digit", // Ensure the month is two digits
        year: "numeric", // Full year
      });
      const time = new Date(
        fixture.fixture.timestamp * 1000,
      ).toLocaleTimeString("no-NO", { hour: "2-digit", minute: "2-digit" });
      const fixtureId = fixture.fixture.id;

      fixturesFixed.push({
        aboutBusiness: fixture.league.name + " - " + fixture.league.round,
        aboutBusinessLang: {
          en_US: fixture.league.name + " - " + fixture.league.round,
          nb_NO: fixture.league.name + " - " + fixture.league.round,
        },
        aboutEvent:
          "Dato: " +
          date +
          "\nTid: " +
          time +
          "\nBilletter fås kjøpt her: " +
          ticketURL,
        aboutEventLang: {
          nb_NO:
            "Dato: " +
            date +
            "\nTid: " +
            time +
            "\nBilletter fås kjøpt her: " +
            ticketURL,
          en_US:
            "Date: " +
            date +
            "\nTime: " +
            time +
            "\nTickets can be purchased here: " +
            ticketURL,
        },
        active: false,
        averagePrice: null,
        currency: currency,
        endDate: fixture.fixture.timestamp + 86400,
        eventDate: fixture.fixture.timestamp,
        eventTime: time,
        eventDateTime: new Date(fixture.fixture.timestamp * 1000),
        eventOrganiser: eventLocation.id,
        eventOrganiserName: eventLocation.data().locationName,
        g: eventLocation.data().g,
        lang: lang,
        locationName: nameFix + " vs " + fixture.teams.away.name,
        locationTags: [fixture.league.name],
        locationTagsLang: {
          [lang]: [fixture.league.name],
          en_US: [fixture.league.name],
        },
        mainProfileImage: fixture.league.logo,
        fixtureId: fixtureId,
        paymentPrice: 0,
        shownOnBusinessPage: true,
        startDate: 0,
        tags: [fixture.league.name, "Fotball", "Sport", "Sportsarrangement"],
        tagsLang: {
          [lang]: [
            fixture.league.name,
            "Fotball",
            "Sport",
            "Sportsarrangement",
          ],
          en_US: [fixture.league.name, "Football", "Sport", "Sportsevent"],
        },
        type: "event",
      });
    });
    setFixtures(fixturesFixed);
  };

  const onAddSportsEvents = async () => {
    const eventsRef = collection(db, "events");
    const userInfoRef = doc(db, "businesses", currentBusinessID);

    const userInformation = await getDoc(userInfoRef);
    const userData = userInformation.data();

    let businessEvents = Array.isArray(userData?.events)
      ? [...userData.events]
      : [];

    // Get existing events for this location
    const existingQuery = query(
      eventsRef,
      where("eventOrganiser", "==", eventLocation.id),
    );

    const existingSnap = await getDocs(existingQuery);

    const existingFixtures = {};
    const existingEventIds = {};

    existingSnap.forEach((docSnap) => {
      const data = docSnap.data();

      if (data.fixtureId) {
        existingFixtures[data.fixtureId] = docSnap.id;
        existingEventIds[docSnap.id] = true;
      }
    });

    const apiFixtureIds = fixtures.map((f) => f.fixtureId);

    const batch = writeBatch(db);

    // CREATE or UPDATE
    for (const fixture of fixtures) {
      const existingDocId = existingFixtures[fixture.fixtureId];

      const existingData = existingDocId
        ? existingSnap.docs.find((d) => d.id === existingDocId)?.data()
        : null;

      const payload = {
        ...fixture,

        // preserve manual values
        active: existingData?.active ?? fixture.active,
        shownOnBusinessPage:
          existingData?.shownOnBusinessPage ?? fixture.shownOnBusinessPage,

        lat: eventLocation.data().lat,
        lng: eventLocation.data().lng,

        coordinates: new firebase.firestore.GeoPoint(
          eventLocation.data().lat,
          eventLocation.data().lng,
        ),

        updatedAt: serverTimestamp(),
      };

      if (existingDocId) {
        // UPDATE
        const docRef = doc(db, "events", existingDocId);
        batch.update(docRef, payload);

        if (!businessEvents.includes(existingDocId)) {
          businessEvents.push(existingDocId);
        }
      } else {
        // CREATE
        const newRef = doc(eventsRef);

        batch.set(newRef, {
          ...payload,
          createdFromTMAt: serverTimestamp(),
        });

        businessEvents.push(newRef.id);
      }
    }

    // DELETE removed fixtures
    for (const fixtureId in existingFixtures) {
      if (!apiFixtureIds.includes(Number(fixtureId))) {
        const docId = existingFixtures[fixtureId];
        const docRef = doc(db, "events", docId);

        batch.delete(docRef);

        businessEvents = businessEvents.filter((id) => id !== docId);
      }
    }

    await batch.commit();

    // update business document
    await updateDoc(userInfoRef, {
      events: businessEvents,
      autoFillSportsIDs: selectedTeams.map((team) => team.id),
      autoFillSportsEventsClubs: selectedTeams.map((team) => team.name),
      autoFillSportsEventsOrganisers: selectedTeams.map(() => eventLocation.id),
      autoFillSportsEventsOrganisersName: selectedTeams.map(
        () => eventLocation.data().locationName,
      ),
      lastTmSyncAt: serverTimestamp(),
    });

    console.log("Sports fixtures synced");

    window.location.reload();
  };

  return (
    <>
      {eventLocation == null ? (
        businessLocations.length > 0 ? (
          businessLocations.map((lokasjonsInformasjon, rowIndex) => {
            return (
              <div
                key={rowIndex}
                className='box'
                style={{ marginBottom: "15px" }}>
                <div className='businessOverView'>
                  <label className='locationNameLabel'>
                    {lokasjonsInformasjon.data()?.locationName}
                  </label>
                  <label>
                    {lokasjonsInformasjon.data()?.adress
                      ? lokasjonsInformasjon.data()?.adress
                      : "-"}
                  </label>
                  <div>
                    <a
                      onClick={() => {
                        setEventLocation(lokasjonsInformasjon);
                      }}
                      className='universalButtonRed'
                      style={{ marginLeft: "5px" }}>
                      Velg
                    </a>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p style={{ textAlign: "center", marginTop: 0 }}>
            Ingen lokasjoner å vise til
          </p>
        )
      ) : (
        <>
          <h3>Velg land</h3>
          <select
            value={selectedCountry}
            onChange={(e) => {
              const country = e.target.value;
              setSelectedCountry(country);
              onGetTeamsFromCountry(country); // ✅ pass directly
            }}>
            {countries.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
          {data && (
            <div>
              <h2>Football Teams in {selectedCountry}:</h2>
              <input
                type='text'
                placeholder='Search teams...'
                onChange={(x) => setSearchTerm(x.target.value)}
                style={{ width: 250 }}
              />
              {selectedTeams.length > 0 && (
                <>
                  <p>Selected Teams:</p>
                  <ul>
                    {selectedTeams.map((teamInfo) => (
                      <li
                        key={teamInfo.id}
                        onClick={() =>
                          handleSelect(teamInfo)({
                            target: {
                              checked: !selectedTeams.some(
                                (t) => t.id === teamInfo.id,
                              ),
                            },
                          })
                        }
                        style={{
                          listStyle: "none",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          width: "200px",
                          padding: "4px 0",
                        }}>
                        <input
                          type='checkbox'
                          checked={selectedTeams.some(
                            (t) => t.id === teamInfo.id,
                          )}
                          onChange={handleSelect(teamInfo)} // ✅ use correct casing
                          style={{
                            width: "16px",
                            height: "16px",
                            marginRight: "8px",
                            pointerEvents: "none", // ✅ allows clicking the whole <li>
                          }}
                        />
                        {teamInfo.name}
                      </li>
                    ))}
                  </ul>
                  {fixtures.length > 0 ? (
                    <>
                      <button
                        className='universalButton'
                        onClick={() => window.location.reload()}>
                        Avbryt
                      </button>
                      <button
                        className='universalButtonRed'
                        onClick={onAddSportsEvents}>
                        Legg til arrangementer
                      </button>
                    </>
                  ) : (
                    <button
                      className='universalButtonRed'
                      onClick={getFixtures}>
                      Fortsett med valgte
                    </button>
                  )}
                  <hr />
                </>
              )}
              <ul>
                {fixtures.length < 1
                  ? filteredData.map((teamInfo) => (
                      <li
                        key={teamInfo.team.id}
                        onClick={() =>
                          handleSelect(teamInfo.team)({
                            target: {
                              checked: !selectedTeams.some(
                                (t) => t.id === teamInfo.team.id,
                              ),
                            },
                          })
                        }
                        style={{
                          listStyle: "none",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          width: "200px",
                          padding: "4px 0",
                        }}>
                        <input
                          type='checkbox'
                          checked={selectedTeams.some(
                            (t) => t.id === teamInfo.team.id,
                          )}
                          onChange={handleSelect(teamInfo.team)} // ✅ use correct casing
                          style={{
                            width: "16px",
                            height: "16px",
                            marginRight: "8px",
                            pointerEvents: "none", // ✅ allows clicking the whole <li>
                          }}
                        />
                        {teamInfo.team.name}
                      </li>
                    ))
                  : fixtures.map((fixture, index) => (
                      <div
                        style={{
                          marginBottom: 10,
                          marginRight: 15,
                          maringleft: 15,
                          backgroundColor: "#F6F5F0",
                          borderRadius: 10,
                        }}>
                        <div
                          style={{
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}>
                          <div
                            style={{
                              marginTop: 10,
                              position: "relative",
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                            }}>
                            <div
                              style={{
                                borderRadius: 100,
                                width: 100,
                                height: 100,
                                paddingLeft: 2,
                                paddingBottom: 1,
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#EDEDED",
                                marginRight: 8,
                                marginLeft: 10,
                              }}>
                              <img
                                style={{
                                  borderRadius: 100,
                                  width: 100,
                                  height: 100,
                                  resize: "contain",
                                }}
                                src={fixture.mainProfileImage}
                              />
                            </div>
                            <div style={{ marginRight: 130 }}>
                              <label
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                  fontSize: 18,
                                  marginBottom: 2,
                                  fontFamily: "Inter",
                                }}>
                                {fixture.locationName}
                              </label>
                              {fixture.locationTags.length > 0 && (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                  }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      textAlign: "center",
                                      paddingLeft: 10,
                                      paddingRight: 10,
                                      width: "auto",
                                      borderRadius: 10,
                                      marginBottom: 2,
                                      marginRight: 3,
                                      backgroundColor: "#4550E2",
                                      color: "white",
                                      fontSize: 12,
                                    }}>
                                    {fixture.locationTags[0]}
                                  </div>
                                </div>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  marginTop: 12,
                                  marginBottom: 10,
                                  width: "100%",
                                }}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}>
                                  <label
                                    style={{
                                      color: "black",
                                      fontSize: 14,
                                    }}>
                                    Dato:{" "}
                                    {new Date(
                                      fixture.eventDate * 1000,
                                    ).toLocaleDateString("nb-NO", {
                                      day: "2-digit", // Ensure the day is two digits
                                      month: "2-digit", // Ensure the month is two digits
                                      year: "numeric", // Full year
                                    })}
                                  </label>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}>
                                  <label
                                    style={{
                                      color: "black",
                                      fontSize: 14,
                                    }}>
                                    Tid: {fixture.eventTime}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
              </ul>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SportsAPIComponent;
